/**
 * Helper function to validate if crop data contains valid dimensions
 * @param cropData - The crop data object to validate
 * @returns boolean - true if the crop data is valid, false otherwise
 */
export const isCropValid = (cropData: any): boolean => {
  if (!cropData) return false;

  const croppingWidth = Number(cropData?.croppingWidth);
  const croppingHeight = Number(cropData?.croppingHeight);
  const width = Number(cropData?.width);
  const height = Number(cropData?.height);

  return croppingWidth > 0 && croppingHeight > 0 && width > 0 && height > 0;
};
